export function getInitials(nameOrEmail) {
  if (!nameOrEmail) return "";
  
  const s = String(nameOrEmail).trim();
  if (!s) return "";

  if (s.includes("@")) {
    const local = s.split("@")[0] || "";
    const parts = local.split(/[\._\-\+]+/).filter(Boolean);


    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }

 
    if (local.length >= 2) {
      return local.slice(0, 2).toUpperCase();
    }

    return (local[0] || "").toUpperCase();
  }

  const parts = s.split(" ").filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function getCurrentUsersName(email, userData) {
  if (!email || !Array.isArray(userData)) return "";

  const matchedUser = userData.find((user) => user.email === email);
  return matchedUser?.name ?? "";
}

export function getFirstName(nameOrEmail) {
  if (!nameOrEmail) return "";

  const value = String(nameOrEmail).trim();
  if (!value) return "";

  if (value.includes("@")) {
    const local = value.split("@")[0];
    const firstName = local.split(/[._+-]+/)[0];

    return firstName
      ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
      : "";
  }

  return value.split(/\s+/)[0];
}


export function isUserInGroup(user, groupName) {
  if (!user) return false;
  const groups = user.profile?.["cognito:groups"];
  if (!groups) return false;
  if (Array.isArray(groups)) return groups.includes(groupName);
  if (typeof groups === "string") return groups.split(',').map(s => s.trim()).includes(groupName);
  return false;
}